// extracted by mini-css-extract-plugin
export default {"highlightClassName":"HighlightedText_highlightClassName__wZO4k"};